/*
	Coloca um elemento como último child de head
*/
export default element => 
	document.head.append(element)
